// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cpe-page.cpe {
  --cpe-text: #111827;
  --cpe-muted: #4b5563;
  --cpe-line: #e5e7eb;
  --cpe-bg: #ffffff;
  --cpe-soft: #f9fafb;
  --cpe-card: #ffffff;
  --cpe-accent: #111827;
  --cpe-radius: 14px;
  background: var(--cpe-bg);
  color: var(--cpe-text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", "Helvetica Neue", Arial, sans-serif;
  line-height: 1.7;
}

#cpe-page .cpe__container {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 18px 16px 56px;
}

/* Top full-width hero image (within this section) */
#cpe-page .cpe__topHero {
  width: 100%;
  border-bottom: 1px solid var(--cpe-line);
  background: var(--cpe-soft);
}

#cpe-page .cpe__topHeroInner {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 16px;
}

#cpe-page .cpe__topHeroImg {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 0;
}

#cpe-page .cpe__heroText {
  margin-top: 18px;
  padding: 18px;
  border: 1px solid var(--cpe-line);
  border-radius: var(--cpe-radius);
  background: var(--cpe-card);
}

#cpe-page .cpe__heroTitle {
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}

#cpe-page .cpe__heroSub {
  margin: 0 0 14px;
  color: var(--cpe-muted);
  font-size: 15px;
}

#cpe-page .cpe__heroPoints {
  margin: 0;
  padding-left: 18px;
  color: var(--cpe-text);
  font-size: 14px;
}

#cpe-page .cpe__heroPoints li {
  margin: 6px 0;
}

#cpe-page .cpe__ctaRow {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

#cpe-page .cpe__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 10px 14px;
  font-size: 14px;
  text-decoration: none;
  border: 1px solid var(--cpe-line);
  color: var(--cpe-text);
  background: var(--cpe-card);
  transition: background 150ms ease, border-color 150ms ease;
  white-space: nowrap;
}

#cpe-page .cpe__btn:hover {
  background: var(--cpe-soft);
  border-color: #d1d5db;
}

#cpe-page .cpe__btn--primary {
  background: var(--cpe-accent);
  border-color: var(--cpe-accent);
  color: #ffffff;
}

#cpe-page .cpe__btn--primary:hover {
  background: #0b1220;
  border-color: #0b1220;
}

#cpe-page .cpe__section {
  margin-top: 22px;
  padding: 18px;
  border: 1px solid var(--cpe-line);
  border-radius: var(--cpe-radius);
  background: var(--cpe-card);
}

#cpe-page .cpe__sectionTitle {
  font-size: 18px;
  margin: 0 0 10px;
  letter-spacing: -0.01em;
}

#cpe-page .cpe__p {
  margin: 0 0 10px;
  color: var(--cpe-text);
  font-size: 14px;
}

#cpe-page .cpe__muted {
  color: var(--cpe-muted);
}

#cpe-page .cpe__list {
  margin: 0;
  padding-left: 18px;
  font-size: 14px;
  color: var(--cpe-text);
}

#cpe-page .cpe__list li {
  margin: 6px 0;
}

#cpe-page .cpe__grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

#cpe-page .cpe__card {
  border: 1px solid var(--cpe-line);
  border-radius: var(--cpe-radius);
  padding: 16px;
  background: var(--cpe-card);
}

#cpe-page .cpe__planTop {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
}

#cpe-page .cpe__planName {
  margin: 0;
  font-size: 16px;
  letter-spacing: -0.01em;
}

#cpe-page .cpe__badge {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--cpe-line);
  background: var(--cpe-soft);
  color: var(--cpe-text);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  white-space: nowrap;
}

#cpe-page .cpe__price {
  font-size: 20px;
  font-weight: 700;
  margin: 10px 0 4px;
  letter-spacing: -0.02em;
}

#cpe-page .cpe__priceNote {
  font-size: 12px;
  margin: 0 0 10px;
  color: var(--cpe-muted);
}

#cpe-page .cpe__kv {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 8px 12px;
  margin-top: 10px;
  font-size: 13px;
}

#cpe-page .cpe__kv dt {
  margin: 0;
  color: var(--cpe-muted);
}

#cpe-page .cpe__kv dd {
  margin: 0;
  color: var(--cpe-text);
}

#cpe-page .cpe__divider {
  height: 1px;
  background: var(--cpe-line);
  margin: 12px 0;
}

#cpe-page .cpe__noteBox {
  background: var(--cpe-soft);
  border: 1px dashed #d1d5db;
  border-radius: var(--cpe-radius);
  padding: 12px 14px;
  font-size: 13px;
  color: var(--cpe-text);
}

#cpe-page .cpe__noteBox strong {
  font-weight: 700;
}

#cpe-page .cpe__fineprint {
  font-size: 12px;
  color: var(--cpe-muted);
  margin: 10px 0 0;
}

#cpe-page .cpe__tableWrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--cpe-line);
  border-radius: var(--cpe-radius);
  background: var(--cpe-card);
}

#cpe-page .cpe__table {
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
  font-size: 13px;
}

#cpe-page .cpe__table th,
#cpe-page .cpe__table td {
  padding: 12px 12px;
  border-bottom: 1px solid var(--cpe-line);
  vertical-align: top;
  text-align: left;
}

#cpe-page .cpe__table th {
  background: var(--cpe-soft);
  font-weight: 700;
}

#cpe-page .cpe__table tr:last-child td {
  border-bottom: none;
}

/* RWD */
@media (max-width: 900px) {
  #cpe-page .cpe__grid2 {
    grid-template-columns: 1fr;
  }
  #cpe-page .cpe__kv {
    grid-template-columns: 110px 1fr;
  }
}
@media (max-width: 420px) {
  #cpe-page .cpe__heroTitle {
    font-size: 24px;
  }
  #cpe-page .cpe__btn {
    width: 100%;
  }
  #cpe-page .cpe__kv {
    grid-template-columns: 1fr;
  }
  #cpe-page .cpe__kv dt {
    color: var(--cpe-muted);
    font-weight: 700;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/cpe/styles/cpe.scss"],"names":[],"mappings":"AAAA;EACM,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,yBAAA;EACA,sBAAA;EACA,4JAAA;EAEA,gBAAA;AADN;;AAII;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AADN;;AAII,oDAAA;AACA;EACE,WAAA;EACA,wCAAA;EACA,2BAAA;AADN;;AAII;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AADN;;AAII;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AADN;;AAII;EACE,gBAAA;EACA,aAAA;EACA,iCAAA;EACA,gCAAA;EACA,2BAAA;AADN;;AAII;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;AADN;;AAII;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AADN;;AAII;EACE,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AADN;;AAII;EACE,aAAA;AADN;;AAII;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AADN;;AAII;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iCAAA;EACA,sBAAA;EACA,2BAAA;EACA,0DAAA;EACA,mBAAA;AADN;;AAII;EACE,2BAAA;EACA,qBAAA;AADN;;AAII;EACE,6BAAA;EACA,+BAAA;EACA,cAAA;AADN;;AAII;EACE,mBAAA;EACA,qBAAA;AADN;;AAII;EACE,gBAAA;EACA,aAAA;EACA,iCAAA;EACA,gCAAA;EACA,2BAAA;AADN;;AAII;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AADN;;AAII;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AADN;;AAII;EACE,uBAAA;AADN;;AAII;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AADN;;AAII;EACE,aAAA;AADN;;AAII;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AADN;;AAII;EACE,iCAAA;EACA,gCAAA;EACA,aAAA;EACA,2BAAA;AADN;;AAII;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AADN;;AAII;EACE,SAAA;EACA,eAAA;EACA,uBAAA;AADN;;AAII;EACE,oBAAA;EACA,mBAAA;EACA,iCAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AADN;;AAII;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AADN;;AAII;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AADN;;AAII;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AADN;;AAII;EACE,SAAA;EACA,uBAAA;AADN;;AAII;EACE,SAAA;EACA,sBAAA;AADN;;AAII;EACE,WAAA;EACA,2BAAA;EACA,cAAA;AADN;;AAII;EACE,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AADN;;AAII;EACE,gBAAA;AADN;;AAII;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;AADN;;AAII;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,gCAAA;EACA,2BAAA;AADN;;AAII;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AADN;;AAII;;EAEE,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AADN;;AAII;EACE,2BAAA;EACA,gBAAA;AADN;;AAII;EACE,mBAAA;AADN;;AAII,QAAA;AACA;EACE;IACE,0BAAA;EADN;EAGI;IACE,gCAAA;EADN;AACF;AAII;EACE;IACE,eAAA;EAFN;EAII;IACE,WAAA;EAFN;EAII;IACE,0BAAA;EAFN;EAII;IACE,uBAAA;IACA,gBAAA;EAFN;AACF","sourcesContent":["#cpe-page.cpe {\r\n      --cpe-text: #111827;\r\n      --cpe-muted: #4b5563;\r\n      --cpe-line: #e5e7eb;\r\n      --cpe-bg: #ffffff;\r\n      --cpe-soft: #f9fafb;\r\n      --cpe-card: #ffffff;\r\n      --cpe-accent: #111827;\r\n      --cpe-radius: 14px;\r\n\r\n      background: var(--cpe-bg);\r\n      color: var(--cpe-text);\r\n      font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Noto Sans TC\",\r\n        \"PingFang TC\", \"Microsoft JhengHei\", \"Helvetica Neue\", Arial, sans-serif;\r\n      line-height: 1.7;\r\n    }\r\n\r\n    #cpe-page .cpe__container {\r\n      width: 100%;\r\n      max-width: 1080px;\r\n      margin: 0 auto;\r\n      padding: 18px 16px 56px;\r\n    }\r\n\r\n    /* Top full-width hero image (within this section) */\r\n    #cpe-page .cpe__topHero {\r\n      width: 100%;\r\n      border-bottom: 1px solid var(--cpe-line);\r\n      background: var(--cpe-soft);\r\n    }\r\n\r\n    #cpe-page .cpe__topHeroInner {\r\n      width: 100%;\r\n      max-width: 1080px;\r\n      margin: 0 auto;\r\n      padding: 0 16px;\r\n    }\r\n\r\n    #cpe-page .cpe__topHeroImg {\r\n      width: 100%;\r\n      height: auto;\r\n      display: block;\r\n      border-radius: 0;\r\n    }\r\n\r\n    #cpe-page .cpe__heroText {\r\n      margin-top: 18px;\r\n      padding: 18px;\r\n      border: 1px solid var(--cpe-line);\r\n      border-radius: var(--cpe-radius);\r\n      background: var(--cpe-card);\r\n    }\r\n\r\n    #cpe-page .cpe__heroTitle {\r\n      font-size: 28px;\r\n      line-height: 1.25;\r\n      margin: 0 0 8px;\r\n      letter-spacing: -0.02em;\r\n    }\r\n\r\n    #cpe-page .cpe__heroSub {\r\n      margin: 0 0 14px;\r\n      color: var(--cpe-muted);\r\n      font-size: 15px;\r\n    }\r\n\r\n    #cpe-page .cpe__heroPoints {\r\n      margin: 0;\r\n      padding-left: 18px;\r\n      color: var(--cpe-text);\r\n      font-size: 14px;\r\n    }\r\n\r\n    #cpe-page .cpe__heroPoints li {\r\n      margin: 6px 0;\r\n    }\r\n\r\n    #cpe-page .cpe__ctaRow {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 10px;\r\n      margin-top: 14px;\r\n    }\r\n\r\n    #cpe-page .cpe__btn {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 999px;\r\n      padding: 10px 14px;\r\n      font-size: 14px;\r\n      text-decoration: none;\r\n      border: 1px solid var(--cpe-line);\r\n      color: var(--cpe-text);\r\n      background: var(--cpe-card);\r\n      transition: background 150ms ease, border-color 150ms ease;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    #cpe-page .cpe__btn:hover {\r\n      background: var(--cpe-soft);\r\n      border-color: #d1d5db;\r\n    }\r\n\r\n    #cpe-page .cpe__btn--primary {\r\n      background: var(--cpe-accent);\r\n      border-color: var(--cpe-accent);\r\n      color: #ffffff;\r\n    }\r\n\r\n    #cpe-page .cpe__btn--primary:hover {\r\n      background: #0b1220;\r\n      border-color: #0b1220;\r\n    }\r\n\r\n    #cpe-page .cpe__section {\r\n      margin-top: 22px;\r\n      padding: 18px;\r\n      border: 1px solid var(--cpe-line);\r\n      border-radius: var(--cpe-radius);\r\n      background: var(--cpe-card);\r\n    }\r\n\r\n    #cpe-page .cpe__sectionTitle {\r\n      font-size: 18px;\r\n      margin: 0 0 10px;\r\n      letter-spacing: -0.01em;\r\n    }\r\n\r\n    #cpe-page .cpe__p {\r\n      margin: 0 0 10px;\r\n      color: var(--cpe-text);\r\n      font-size: 14px;\r\n    }\r\n\r\n    #cpe-page .cpe__muted {\r\n      color: var(--cpe-muted);\r\n    }\r\n\r\n    #cpe-page .cpe__list {\r\n      margin: 0;\r\n      padding-left: 18px;\r\n      font-size: 14px;\r\n      color: var(--cpe-text);\r\n    }\r\n\r\n    #cpe-page .cpe__list li {\r\n      margin: 6px 0;\r\n    }\r\n\r\n    #cpe-page .cpe__grid2 {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 14px;\r\n    }\r\n\r\n    #cpe-page .cpe__card {\r\n      border: 1px solid var(--cpe-line);\r\n      border-radius: var(--cpe-radius);\r\n      padding: 16px;\r\n      background: var(--cpe-card);\r\n    }\r\n\r\n    #cpe-page .cpe__planTop {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 10px;\r\n      align-items: baseline;\r\n      justify-content: space-between;\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n    #cpe-page .cpe__planName {\r\n      margin: 0;\r\n      font-size: 16px;\r\n      letter-spacing: -0.01em;\r\n    }\r\n\r\n    #cpe-page .cpe__badge {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      border: 1px solid var(--cpe-line);\r\n      background: var(--cpe-soft);\r\n      color: var(--cpe-text);\r\n      border-radius: 999px;\r\n      padding: 4px 10px;\r\n      font-size: 12px;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    #cpe-page .cpe__price {\r\n      font-size: 20px;\r\n      font-weight: 700;\r\n      margin: 10px 0 4px;\r\n      letter-spacing: -0.02em;\r\n    }\r\n\r\n    #cpe-page .cpe__priceNote {\r\n      font-size: 12px;\r\n      margin: 0 0 10px;\r\n      color: var(--cpe-muted);\r\n    }\r\n\r\n    #cpe-page .cpe__kv {\r\n      display: grid;\r\n      grid-template-columns: 120px 1fr;\r\n      gap: 8px 12px;\r\n      margin-top: 10px;\r\n      font-size: 13px;\r\n    }\r\n\r\n    #cpe-page .cpe__kv dt {\r\n      margin: 0;\r\n      color: var(--cpe-muted);\r\n    }\r\n\r\n    #cpe-page .cpe__kv dd {\r\n      margin: 0;\r\n      color: var(--cpe-text);\r\n    }\r\n\r\n    #cpe-page .cpe__divider {\r\n      height: 1px;\r\n      background: var(--cpe-line);\r\n      margin: 12px 0;\r\n    }\r\n\r\n    #cpe-page .cpe__noteBox {\r\n      background: var(--cpe-soft);\r\n      border: 1px dashed #d1d5db;\r\n      border-radius: var(--cpe-radius);\r\n      padding: 12px 14px;\r\n      font-size: 13px;\r\n      color: var(--cpe-text);\r\n    }\r\n\r\n    #cpe-page .cpe__noteBox strong {\r\n      font-weight: 700;\r\n    }\r\n\r\n    #cpe-page .cpe__fineprint {\r\n      font-size: 12px;\r\n      color: var(--cpe-muted);\r\n      margin: 10px 0 0;\r\n    }\r\n\r\n    #cpe-page .cpe__tableWrap {\r\n      width: 100%;\r\n      overflow-x: auto;\r\n      border: 1px solid var(--cpe-line);\r\n      border-radius: var(--cpe-radius);\r\n      background: var(--cpe-card);\r\n    }\r\n\r\n    #cpe-page .cpe__table {\r\n      width: 100%;\r\n      border-collapse: collapse;\r\n      min-width: 720px;\r\n      font-size: 13px;\r\n    }\r\n\r\n    #cpe-page .cpe__table th,\r\n    #cpe-page .cpe__table td {\r\n      padding: 12px 12px;\r\n      border-bottom: 1px solid var(--cpe-line);\r\n      vertical-align: top;\r\n      text-align: left;\r\n    }\r\n\r\n    #cpe-page .cpe__table th {\r\n      background: var(--cpe-soft);\r\n      font-weight: 700;\r\n    }\r\n\r\n    #cpe-page .cpe__table tr:last-child td {\r\n      border-bottom: none;\r\n    }\r\n\r\n    /* RWD */\r\n    @media (max-width: 900px) {\r\n      #cpe-page .cpe__grid2 {\r\n        grid-template-columns: 1fr;\r\n      }\r\n      #cpe-page .cpe__kv {\r\n        grid-template-columns: 110px 1fr;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 420px) {\r\n      #cpe-page .cpe__heroTitle {\r\n        font-size: 24px;\r\n      }\r\n      #cpe-page .cpe__btn {\r\n        width: 100%;\r\n      }\r\n      #cpe-page .cpe__kv {\r\n        grid-template-columns: 1fr;\r\n      }\r\n      #cpe-page .cpe__kv dt {\r\n        color: var(--cpe-muted);\r\n        font-weight: 700;\r\n      }\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
